import * as React from 'react'
import { View, Text, TouchableOpacity } from 'react-native'
import styled from '@theme/styled-components'

import Icon from '@components/icon/Icons'
import TextInputComponent from '@components/textInput/TextInput'

import theme from '@theme/Theme'
import useI18n from '@i18n/useI18n'
import useNavigation from '@layout/useNavigation'

type Props = {
  onFilter: () => void
  onExport: () => void
  setSearch: (text: string) => void
  searchText: string
  onLeft?: () => void
  displayExport: boolean
  exportStatus?: ButtonStatus
  numberOfFilters: number
}

const UserListHeader = ({
  onFilter,
  onExport,
  setSearch,
  searchText,
  onLeft,
  displayExport,
  exportStatus,
  numberOfFilters,
}: Props) => {
  const i18n = useI18n()
  const navigation = useNavigation()

  return (
    <MainContainer>
      <ContentContainer>
        <LeftButton activeOpacity={0.9} onPress={onLeft || (() => navigation.goBack())}>
          <Icon name="arrow-left" size={35} color={theme.colors.background} />
        </LeftButton>

        <Title>{i18n.t('screens.admin.users.title')}</Title>
        <RightContainer>
          <ButtonContainer>
            <TouchableOpacity activeOpacity={0.9} onPress={onFilter}>
              {numberOfFilters > 0 && <FilterIndicator>{numberOfFilters}</FilterIndicator>}
              <Icon name="filter" size={25} color={theme.colors.background} />
            </TouchableOpacity>
            {displayExport && (
              <TouchableOpacity activeOpacity={0.9} onPress={onExport} disabled={exportStatus !== 'active'}>
                <Icon name="download" size={25} color={theme.colors.background} />
              </TouchableOpacity>
            )}
          </ButtonContainer>
        </RightContainer>
      </ContentContainer>
      <SubHeader>
        <TextInputComponent
          onChange={setSearch}
          searchStyle="onDark"
          placeholder={i18n.t('screens.incidentList.search')}
          left={{ name: 'search' }}
          value={searchText}
        />
      </SubHeader>
    </MainContainer>
  )
}

export default UserListHeader

const MainContainer = styled(View)`
  padding: 16px;
  background-color: ${(props) => props.theme.colors.primary};
`

const ContentContainer = styled(View)`
  flex-direction: row;
  align-items: center;
  height: 30px;
  margin-top: ${(props) => props.theme.insets.top}px;
`

const Title = styled(Text)`
  ${(props) => props.theme.fonts.Headline};
  color: ${(props) => props.theme.colors.background};
  flex: 2;
  text-align: center;
`
const RightContainer = styled(View)`
  flex: 1;
  align-items: flex-end;
`
const LeftButton = styled(TouchableOpacity)`
  flex: 1;
  align-items: flex-start;
`

const ButtonContainer = styled(View)`
  width: 80px;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
`

const SubHeader = styled(View)`
  margin-top: 20px;
`
const FilterIndicator = styled(Text)`
  background-color: ${(props) => props.theme.colors.alertButton};
  border-radius: 8px;
  position: absolute;
  top: -4px;
  right: -4px;
  min-height: 14px;
  min-width: 14px;
  ${(props) => props.theme.fonts.Caption2};
  color: ${(props) => props.theme.colors.background};
  text-align: center;
`
